module.exports = __webpack_public_path__ + "static/media/athoslabs.a6cc0127.png";